export default __webpack_public_path__ + "static/images/pdfIcon.3e1bb7c3.svg";